<template>
  <el-button
    class="type-button ordinary"
    round
    :class="[converse ? 'converse' : '']"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <slot>{{ this.type }}</slot>
  </el-button>
</template>

<script>
// const size = {
//   width:100,
//   height:50
// }
export default {
  name: "type-button",
  props: {
    type: {
      type: [String, undefined],
      default: undefined
    },
    icon: {
      type: [String, undefined],
      default: undefined
    },
    color: {
      type: [String, undefined],
      default: undefined
    },
    converse:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    // findTypes() {
    //   switch (this.type) {
    //     case "删除":
    //       return {
    //         color: "danger",
    //         icon: "el-icon-delete"
    //       }
    //   }
    // },
  //   classes() {
  //     const color = this.color ? this.color : this.findTypes.color
  //     return `${color}--text`
  //   },
  //   iconfont() {
  //     return this.icon ? this.icon : this.findTypes.icon
  //   }
  }
}
</script>
<style>

.el-button.type-button{
  padding:0
}
</style>
<style lang="scss" scoped>
.orange {
  color: #ff5400 !important;
}
.orange.is-disabled {
  color: #d8d9db !important;
}
.gray {
  color: #666666 !important;
}
.gray.is-disabled {
  color: #d8d9db !important;
}
.ordinary {
  font-weight: 500;
  color: #FFFFFF;
  background-color: #0C5EE4 !important;
  font-size: 14px;
}
.converse{
    color: #0C5EE4;
     background-color: #FFFFFF !important;
     border-color: #0C5EE4;
}
</style>



// WEBPACK FOOTER //
// src/common/components/ByButton.vue